import guest from "@/core/middlewares/guest";

let login = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/login/Login');
let oneTimePasswordSendCode = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/login/otp/SendCode.vue');
let oneTimePasswordConfirm = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/login/otp/Confirm.vue');

let oauthCallback = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/Oauth');
let twoFactorAuthentication = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/TwoFactorAuthentication');
let forgotPassword = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/forgot-password/ForgotPassword');
let resetPassword = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/forgot-password/ResetPassword');
let sendCode = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/register/SendCode');
let confirm = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/register/confirm');
let register = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/register/register');

export default [
    {
        path: "/accounts",
        redirect: "/accounts/login",
        component: () => import("@/views/authentication/Layout"),
        children: [
            {
                path: "login",
                name: "login",
                component: login,
                meta: {
                    middleware: guest,
                    title: "پنل کاربری میهن شاپ",
                    description: "برای ورود به پنل کاربری میهن شاپ شماره موبایل خود را وارد نمایید. "
                }
            },
            {
                path: "login/otp",
                name: "login.otp",
                component: oneTimePasswordSendCode,
                meta: {
                    middleware: guest,
                    title: "پنل کاربری میهن شاپ",
                    description: "ورود با کد‌ یک بار مصرف"
                }
            },
            {
                path: "login/otp/:token",
                name: "login.otp.confirm",
                component: oneTimePasswordConfirm,
                meta: {
                    middleware: guest,
                    title: "پنل کاربری میهن شاپ",
                    description: "ورود با کد یک ‌بار‌ مصرف"
                }
            },
            {
                path: "oauth/:provider/callback",
                name: "oauth.callback",
                component: oauthCallback,
                meta: {
                    middleware: guest,
                    title: "پنل کاربری میهن شاپ",
                    description: "برای ورود به پنل کاربری میهن شاپ شماره موبایل خود را وارد نمایید. "
                }
            },
            {
                path: "2fa/:token",
                name: "2fa",
                component: twoFactorAuthentication,
                meta: {
                    middleware: guest,
                    title: "ورود دو مرحله ای میهن شاپ",
                    description: "برای ورود دو مرحله ای به پنل کاربری میهن شاپ اطلاعات خود را وارد نمایید. "
                }
            },
            {
                path: "forgot-password",
                name: "forgot-password",
                component: forgotPassword,
                meta: {
                    middleware: guest,
                    title: "فراموشی گذرواژه میهن شاپ",
                    description: "برای تغییر رمز عبور پنل کاربری میهن شاپ ، شماره موبایل را وارد کنید"
                }
            },
            {
                path: "reset-password/:token",
                name: "reset-password",
                component: resetPassword,
                meta: {
                    middleware: guest,
                    title: "بازیابی گذرواژه میهن شاپ",
                    description: "بازیابی گذرواژه پنل کاربری میهن شاپ "
                }
            },
            {
                path: "verify-mobile",
                name: "verify-mobile",
                component: sendCode,
                meta: {
                    middleware: guest,
                    title: "ثبت نام میهن شاپ",
                    description: "جهت ثبت نام در پنل کاربری میهن شاپ لطفا شماره موبایلتان را وارد کنید "
                }
            },
            {
                path: "verify-mobile/:token",
                name: "confirm",
                component: confirm,
                meta: {
                    middleware: guest,
                    title: "تایید شماره همراه میهن شاپ",
                    description: "جهت تایید شماره همراه کد ارسال شده به موبایل تان را وارد نمایید "
                }
            },
            {
                path: "register",
                name: "register",
                component: register,
                meta: {
                    middleware: guest,
                    title: "ثبت نام میهن شاپ",
                    description: "جهت ثبت نام در پنل کاربری میهن شاپ لطفا شماره موبایلتان را وارد کنید "
                }
            },
        ]
    }
]